/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, April 18th 2023, 7:31:26 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { STATUS_CODES } from "lib/api/types";
import { Organization } from "lib/schemas";
import { useSaaSSubscriptionAPI } from "saas-subscription/services/SubscriptionAPI";

export const useSubscribeWithPay = (selectedOrganization: Organization) => {
  const { useCreateCheckoutSession } = useSaaSSubscriptionAPI();
  const {
    createCheckoutSession,
    isAPIError,
    isRedirecting,
    isMakingAPIRequest,
    isSuccessfulAPIRequest,
    httpResponseStatusCode: checkoutAPIResponseCode,
  } = useCreateCheckoutSession();

  const isClientError =
    isAPIError &&
    STATUS_CODES.ClientError <= checkoutAPIResponseCode &&
    checkoutAPIResponseCode < STATUS_CODES.ServerError;

  return {
    handlePurchase: ({ selectedPrice }) => {
      createCheckoutSession(selectedOrganization, selectedPrice.lookup_key);
    },
    isError: isClientError,
    isMakingPurchase: isMakingAPIRequest || isRedirecting,
    isSuccessful: isSuccessfulAPIRequest && !isRedirecting,
  };
};
